import * as _ from 'underscore';
import { ServiceLocator } from '../../app/ServiceLocator';
import { CheckboxState } from '../../common/components/checkboxes/CheckboxState';
import { ServerAdminUpdateActionNotification } from './notifications/ServerAdminUpdateActionNotification';
import { IUserInfo } from '../../ts/models/IUserInfo';
import { Set } from '../../ts/models/Set';
import { Module } from '../../ts/Module';
import { IUpdateServerUsersSiteMembershipParams } from '../../ts/ServerApi/requests/UpdateServerUsersSiteMembershipRequest';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { IServerUser } from '../../ts/ServerApi/types/IServerUser';
import { ISiteRole, SiteRoles } from '../../ts/ServerApi/types/ISiteRole';
import { IUserRole } from '../../ts/ServerApi/types/IUserRole';
import { ServerUsers } from './resources/ServerUsers';

export interface IUsersWithSiteRolesModel {
  users: Set<IServerUser>;
  userRoles: IUserRole[];
  serverAdmins: string[]; // user ids
}

export interface ISiteRoleChange {
  checkboxState?: string;
  siteRole?: string;
  siteName: string;
}

const serverAdminUpdateActionNotification: ServerAdminUpdateActionNotification = ServerAdminUpdateActionNotification.instance;

// section: update site membership or roles

// Takes userids and site role changes and package them into a parameter
// object that can be used for backend requests.
function siteRoleChangesToParams(userIds: string[], changes: _.Dictionary<ISiteRoleChange>): IUpdateServerUsersSiteMembershipParams {
  const addToSiteRoles: ISiteRole[] = [];
  const removeFromSiteIds: string[] = [];
  _.each(changes, (change: ISiteRoleChange, siteId: string) => {
    if (change.checkboxState === CheckboxState.checked && change.siteRole in SiteRoles) {
      addToSiteRoles.push({
        siteId: siteId,
        siteRole: change.siteRole
      });
    } else if (change.checkboxState === CheckboxState.empty) {
      removeFromSiteIds.push(siteId);
    }
  });

  return {
    userIds: userIds,
    addToSiteRoles: addToSiteRoles,
    removeFromSiteIds: removeFromSiteIds
  };
}

// Exactly the same as ServerUsers.updateServerUsersSiteMembership, except that
// this one directly takes a parameters object.
function updateServerUsersSiteMembership(params: IUpdateServerUsersSiteMembershipParams): ng.IPromise<any> {
  return ServerUsers.instance.updateServerUsersSiteMembership(
    params.userIds,
    params.addToSiteRoles,
    params.removeFromSiteIds
  );
}

// section: update server admin

function updateServerAdmin(users: Set<IUserInfo>, newAdminState: boolean): ng.IPromise<IResult> {
  const userIds = users.pluck('id');
  const promise: ng.IPromise<IResult> = ServerUsers.instance.updateServerAdminStatus(userIds, newAdminState);

  promise.then((result: IResult) => {
    serverAdminUpdateActionNotification.notify(result, users, newAdminState);
  });

  return promise;
}



export const SiteRolesPickerClientService = {
  siteRoleChangesToParams, updateServerUsersSiteMembership, updateServerAdmin
};
